/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkAssignFormAuditor } from '../fn/bulk-form-actions/bulk-assign-form-auditor';
import { BulkAssignFormAuditor$Params } from '../fn/bulk-form-actions/bulk-assign-form-auditor';
import { bulkUnassignFormAuditor } from '../fn/bulk-form-actions/bulk-unassign-form-auditor';
import { BulkUnassignFormAuditor$Params } from '../fn/bulk-form-actions/bulk-unassign-form-auditor';
import { bulkUpdateFormStatus } from '../fn/bulk-form-actions/bulk-update-form-status';
import { BulkUpdateFormStatus$Params } from '../fn/bulk-form-actions/bulk-update-form-status';
import { FormAuditAssignResponseDto } from '../models/form-audit-assign-response-dto';
import { FormAuditUpdateResponseDto } from '../models/form-audit-update-response-dto';

@Injectable({ providedIn: 'root' })
export class BulkFormActionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bulkFormActionControllerBulkAssignFormAuditor()` */
  static readonly BulkFormActionControllerBulkAssignFormAuditorPath =
    '/auditing/bulk/forms/assignment/{programId}/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkAssignFormAuditor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkAssignFormAuditor$Response(
    params: BulkAssignFormAuditor$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormAuditAssignResponseDto>>> {
    return bulkAssignFormAuditor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkAssignFormAuditor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkAssignFormAuditor(
    params: BulkAssignFormAuditor$Params,
    context?: HttpContext
  ): Observable<Array<FormAuditAssignResponseDto>> {
    return this.bulkAssignFormAuditor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormAuditAssignResponseDto>>): Array<FormAuditAssignResponseDto> => r.body)
    );
  }

  /** Path part for operation `bulkFormActionControllerBulkUnassignFormAuditor()` */
  static readonly BulkFormActionControllerBulkUnassignFormAuditorPath = '/auditing/bulk/forms/assignment/{programId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkUnassignFormAuditor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUnassignFormAuditor$Response(
    params: BulkUnassignFormAuditor$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormAuditAssignResponseDto>>> {
    return bulkUnassignFormAuditor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkUnassignFormAuditor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUnassignFormAuditor(
    params: BulkUnassignFormAuditor$Params,
    context?: HttpContext
  ): Observable<Array<FormAuditAssignResponseDto>> {
    return this.bulkUnassignFormAuditor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormAuditAssignResponseDto>>): Array<FormAuditAssignResponseDto> => r.body)
    );
  }

  /** Path part for operation `bulkFormActionControllerBulkUpdateFormStatus()` */
  static readonly BulkFormActionControllerBulkUpdateFormStatusPath = '/auditing/bulk/forms/status/{reasonCodeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkUpdateFormStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateFormStatus$Response(
    params: BulkUpdateFormStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormAuditUpdateResponseDto>>> {
    return bulkUpdateFormStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkUpdateFormStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateFormStatus(
    params: BulkUpdateFormStatus$Params,
    context?: HttpContext
  ): Observable<Array<FormAuditUpdateResponseDto>> {
    return this.bulkUpdateFormStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormAuditUpdateResponseDto>>): Array<FormAuditUpdateResponseDto> => r.body)
    );
  }
}
